import Model from '@/lib/data/Model';

class ExtensionDef extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'extension_name' },
        { name: 'show_free_text' },
        { name: 'rec_order' },
        { name: 'record_state', type: 'int', defaultValue: 1 },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get isActive() {
        return this.record_state == 1;
    }

    api = [];
}

export default ExtensionDef;
